import api from "./api";

export const searchParcel = async (parcelCode, date) => {
  const { data } = await api.get(`/parcel/${parcelCode}?date=${date}`);

  return data;
};
